import cx from "classnames";
import ReactMarkdown from "react-markdown";
import * as R from "remeda";

import ExternalLink from "./ExternalLink";

interface DescriptionProps {
  text: string;
  docsUrl?: string;
  className?: string;
}

const DescriptionText = ({ text }) => (
  <ReactMarkdown
    allowedElements={["a", "p", "strong", "em"]}
    components={{
      p: "span",
      a: ({ ...props }) => (
        <a
          className="text-blue-300 font-semibold hover:underline"
          {...R.omit(props, ["node"])}
        />
      )
    }}
    linkTarget="_blank"
    skipHtml
  >
    {text}
  </ReactMarkdown>
);

const DocsLink = ({ docsUrl }) => (
  <span style={{ whiteSpace: "nowrap" }}>
    <ExternalLink
      href={docsUrl}
      className="text-blue-300 font-semibold hover:underline"
    >
      Learn more
    </ExternalLink>
  </span>
);

const Description = ({ text, docsUrl, className }: DescriptionProps) => (
  <p
    className={cx(
      "mt-3 text-gray-600 text-sm leading-[1.4]",
      className
    )}
    style={{ paddingLeft: "1px", maxWidth: "1000px" }}
  >
    <DescriptionText text={text} />
    {docsUrl && (
      <>
        {" "}
        <DocsLink docsUrl={docsUrl} />
      </>
    )}
  </p>
);

export default Description;
